import { createRedesignEntry } from "../redesign-page-entry";

export default createRedesignEntry(() => import("./education-page"), {
  testId: "rd-education-loading",
  shell: { activeNav: "learning" },
});
